import Tag from 'src/components/DataDisplay/Tag/Tag'
import { ApplicantStage } from 'src/graphql/types/applicants'
import IconCancel from 'src/icons/IconCancel'
import { formatSnakeValue } from 'src/lib/formatters'

const getStageSettings = (applicant) => {
  const stageMapping = {
    [ApplicantStage.DISQUALIFIED]: {
      variant: 'error',
      message: `${
        applicant.isPermanentlyDisqualified ? `Permanently` : `Temporarily`
      } Disqualified - ${formatSnakeValue(applicant.disqualifiedReason)}`,
    },
    [ApplicantStage.NOT_INTERESTED]: {
      icon: IconCancel,
      variant: 'warning',
      message: `Not Interested - ${formatSnakeValue(
        applicant.notInterestedReason
      )}`,
    },
    [ApplicantStage.TERMINATED]: {
      variant: 'error',
      message: `${
        applicant.eligibleForRehire ? `Eligible` : `Not Eligible`
      } For Rehire - ${formatSnakeValue(applicant.terminatedReason)}`,
    },
    default: {
      variant: 'transparent',
    },
  }

  return stageMapping[applicant.applicantStage] || stageMapping.default
}

const ApplicantStageRow = ({ applicant }) => {
  const { variant, message } = getStageSettings(applicant)

  const messageCard = (message, variant) => (
    <Tag
      size="xs"
      showCloseButton={false}
      variant={variant}
      className="text-[11px]"
    >
      {message}
    </Tag>
  )

  return (
    <div className="flex w-full flex-row items-center gap-2 overflow-auto">
      {(applicant.applicantStage === ApplicantStage.NOT_INTERESTED ||
        applicant.applicantStage === ApplicantStage.TERMINATED ||
        applicant.applicantStage === ApplicantStage.DISQUALIFIED) &&
        messageCard(message, variant)}
    </div>
  )
}

export default ApplicantStageRow
